import React, { Component } from 'react';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';
import { actions } from 'actions';

class RequirementItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: !!+this.props.value
    }
  }

  onChange = ({ currentTarget: { checked } }) => {
    this.setState({ value: checked });

    actions.saveSupplier(this.props.supplierId, { [this.props.fieldKey]: (+checked).toString() });
    this.props.handleSave();
  }

  render() {
    return (
      <TableRow>
        <TableColumn>
          <strong>{this.props.title}</strong>
          <div className="text-xs text-gray-600">{this.props.description}</div>
        </TableColumn>
        <TableColumn>
          <span className="pull-right">
            <input type="checkbox" checked={this.state.value} onChange={this.onChange} />
          </span>
        </TableColumn>
      </TableRow>
    );
  }
}

export { RequirementItem };
